import React from 'react';
import { Grid } from '@material-ui/core';
import _ from 'lodash';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { textBold } from 'styles';
import Content from 'components/basics/Content';
import Markdown from 'utils/markdownToComponent';
import { breakpoint } from 'utils/mediaQueries';

const ContentGrid = styled(Grid)`
  padding-top: 15rem;
  ${breakpoint.down('lg')`
      padding-top: 10rem;`};
  ${breakpoint.down('md')`
      padding-top: 0;`};
  ${Content}
`;
const StyledGrid = styled(Grid)`
  padding: 1rem;
  ${breakpoint.down('lg')`
  flex-direction: row`}
  ${breakpoint.down('md')`
  flex-direction: column`}
  ${breakpoint.down('sm')`
  flex-direction: row; padding:0`}
  
`;
const StyledImg = styled(Img)`
  max-width: 70px;
  width: 100%;
`;

const StyledTypography = styled(Markdown)`
  padding: 2rem;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  ${textBold}
  ${breakpoint.down('lg')`
  text-align:left`}
  ${breakpoint.down('md')`
  text-align:center; padding: 1rem`};
  ${breakpoint.down('sm')`
  text-align:left; padding-left: 2rem`}
  ${breakpoint.down('xs')`
  font-size: ${props => `${props.theme.typography.caption.fontSize}
px`};`};
`;
const BlockObjectives = ({ images, data }) => {
  return (
    <ContentGrid container direction="row" justify="center">
      {data.map((imageMin, index) => {
        const imageFind = _.find(images, function(image) {
          return image.base === imageMin.frontmatter.relatedImage;
        });
        return (
          <StyledGrid
            container
            item
            justify="flex-start"
            wrap="nowrap"
            alignItems="center"
            direction="column"
            xs={9}
            sm={5}
            md={5}
            lg={3}
            key={`BlockObjectives${index}`}
          >
            <StyledImg fluid={imageFind.childImageSharp.fluid} />
            <StyledTypography variant="body2">
              {imageMin.rawMarkdownBody}
            </StyledTypography>
          </StyledGrid>
        );
      })}
    </ContentGrid>
  );
};
export default BlockObjectives;
